import { call, put, takeEvery } from "redux-saga/effects";
import {
  UpdateAccountInfoAction,
  UpdateAccountInfoPersistRequestState,
  UpdateChangePasswordRequestState,
  UpdateCouponAmountRemainingAction,
  UpdateFetchBalanceRequestState,
  UpdateHasUsedCoupon,
  UpdateRedeemCouponRequestState,
  UpdateSignInRequestState,
  UpdateSignUpRequestState,
} from "./action";
import {
  RequestFailedUpdate,
  RequestLoadingUpdate,
  RequestSuccessfulUpdate,
} from "../../request";
import { Post } from "../../api";
import { TransformAuthResponse } from "./transformer";
import { createStandaloneToast } from "@chakra-ui/react";

export function* authenticationSaga() {
  yield takeEvery("authentication-update-sign-in", signIn);
  yield takeEvery("authentication-update-sign-up", signUp);

  yield takeEvery("authentication-fetch-account-details", fetchAccountDetails);
  yield takeEvery(
    "authentication-persist-account-details",
    persistAccountDetails
  );

  yield takeEvery("authentication-change-password", changePassword);

  yield takeEvery("authentication-fetch-balance", fetchBalance);
  yield takeEvery("authentication-redeem-coupon", redeemCoupon);
}

const toast = createStandaloneToast();

function* fetchBalance(action: any) {
  try {
    yield put(UpdateFetchBalanceRequestState(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(Post, "/dashboard/coupon/balance");

    yield put(UpdateCouponAmountRemainingAction(response.balance));
    yield put(UpdateHasUsedCoupon(response.hasUsedCoupon));

    yield put(UpdateFetchBalanceRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateFetchBalanceRequestState(RequestFailedUpdate));
  }
}

function* redeemCoupon(action: any) {
  try {
    yield put(UpdateRedeemCouponRequestState(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(Post, "/dashboard/coupon", {
      code: action.code,
    });

    yield put(UpdateCouponAmountRemainingAction(response.value));

    yield put(UpdateRedeemCouponRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateRedeemCouponRequestState(RequestFailedUpdate));
  }
}

function* signIn(action: any) {
  try {
    yield put(UpdateSignInRequestState(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(Post, "/dashboard/signin", {
      mail: action.mail,
      password: action.password,
    });

    if (!response["jwtToken"]) {
      yield put(UpdateSignInRequestState(RequestFailedUpdate));
      toast({
        title: "Error",
        description: response.err ?? "An error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const authResponse = TransformAuthResponse(response);

    yield put(UpdateAccountInfoAction(authResponse));
    const hasReadOnlyAccess =
      typeof authResponse.hasReadOnlyAccess === "boolean"
        ? authResponse.hasReadOnlyAccess
        : false;
    const isROASCampaignsEnabled =
      typeof authResponse.isROASCampaignsEnabled === "boolean"
        ? authResponse.isROASCampaignsEnabled
        : false;
    const specialMode = authResponse.specialMode;

    localStorage.setItem("jwtToken", response.jwtToken);
    localStorage.setItem("b", authResponse.showBiddingType ? "1" : "0");
    localStorage.setItem("p", authResponse.showPlatformSelection ? "1" : "0");
    localStorage.setItem("r", hasReadOnlyAccess ? "1" : "0");
    localStorage.setItem("rc", isROASCampaignsEnabled ? "1" : "0");
    localStorage.setItem(
      "nm",
      authResponse.isNotificationManagerEnabled ? "1" : "0"
    );

    // main = 1, am = 2, none = 0
    localStorage.setItem(
      "s",
      specialMode
        ? specialMode === "main"
          ? "1"
          : specialMode === "am"
          ? "2"
          : "0"
        : "0"
    );

    yield put(UpdateSignInRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateSignInRequestState(RequestFailedUpdate));
  }
}

function* signUp(action: any) {
  try {
    yield put(UpdateSignUpRequestState(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(Post, "/dashboard/signup", {
      mail: action.mail,
      password: action.password,
      firstName: action.firstName,
      lastName: action.lastName,
      companyName: action.companyName,
      companyStreet: action.companyStreet,
      companyCity: action.companyCity,
      companyPostalCode: action.companyPostalCode,
      companyCountry: action.companyCountry,
      companyVatId: action.companyVatId,
    });

    if (!response["jwtToken"]) {
      yield put(UpdateSignUpRequestState(RequestFailedUpdate));
      toast({
        title: "Error",
        description: response.err ?? "An error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const authResponse = TransformAuthResponse(response);

    yield put(UpdateAccountInfoAction(authResponse));
    const hasReadOnlyAccess =
      typeof authResponse.hasReadOnlyAccess === "boolean"
        ? authResponse.hasReadOnlyAccess
        : false;

    const isROASCampaignsEnabled =
      typeof authResponse.isROASCampaignsEnabled === "boolean"
        ? authResponse.isROASCampaignsEnabled
        : false;

    const specialMode = authResponse.specialMode;

    localStorage.setItem("jwtToken", response.jwtToken);
    localStorage.setItem("b", authResponse.showBiddingType ? "1" : "0");
    localStorage.setItem("p", authResponse.showPlatformSelection ? "1" : "0");
    localStorage.setItem("r", hasReadOnlyAccess ? "1" : "0");
    localStorage.setItem("rc", isROASCampaignsEnabled ? "1" : "0");

    // main = 1, am = 2, none = 0
    localStorage.setItem(
      "s",
      specialMode
        ? specialMode === "main"
          ? "1"
          : specialMode === "am"
          ? "2"
          : "0"
        : "0"
    );

    yield put(UpdateSignUpRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateSignUpRequestState(RequestFailedUpdate));
  }
}

function* fetchAccountDetails(action: any) {
  try {
    //yield put(UpdateAccountInfoPersistRequestState(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(Post, "/dashboard/partner");

    yield put(UpdateAccountInfoAction(TransformAuthResponse(response)));

    //yield put(UpdateAccountInfoPersistRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    //yield put(UpdateAccountInfoPersistRequestState(RequestFailedUpdate));
  }
}

function* persistAccountDetails(action: any) {
  try {
    yield put(UpdateAccountInfoPersistRequestState(RequestLoadingUpdate));

    // @ts-ignore
    const response = yield call(Post, "/dashboard/partner/edit", {
      companyName: action.companyName,
      companyStreet: action.companyStreet,
      companyCity: action.companyCity,
      companyPostalCode: action.companyPostalCode,
      companyCountry: action.companyCountry,
      companyVatId: action.companyVatId === "" ? null : action.companyVatId,
    });

    if (response.err) {
      toast({
        title: "Error",
        description: response.err,
        status: "error",
        duration: 5000,
        isClosable: true,
      });

      return;
    }

    toast({
      title: "Success",
      description: "Your account details have been updated.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    yield put(UpdateAccountInfoPersistRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    yield put(UpdateAccountInfoPersistRequestState(RequestFailedUpdate));
  }
}

function* changePassword(action: any) {
  try {
    yield put(UpdateChangePasswordRequestState(RequestLoadingUpdate));

    // @ts-ignore
    yield call(Post, "/dashboard/password", {
      password: action.password,
      updatedPassword: action.updatedPassword,
    });

    toast({
      title: "Success",
      description: "Your password has been updated.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });

    yield put(UpdateChangePasswordRequestState(RequestSuccessfulUpdate));
  } catch (e) {
    toast({
      title: "Error",
      description: "Old password is incorrect.",
      status: "error",
      duration: 5000,
      isClosable: true,
    });

    yield put(UpdateChangePasswordRequestState(RequestFailedUpdate));
  }
}
